

<template>
	<div class="index-component component-view" :class="mapClass" :style="{backgroundColor:backgroundColor}">
		
		<div class="header">
			<div class="exit" @click="onClickExit"></div>
			<div class="logo">
				<a href="https://www.tetronik-kommunikationstechnik.de/" v-if="!isElectron">
					<img src="assets/images/logo.svg" width="241" height="43" class="img-fluid" />
				</a>
				<router-link to="/page/" v-if="isElectron">
					<img src="assets/images/logo.svg" width="241" height="43" class="img-fluid" />
				</router-link>
			</div>
		</div>

		<transition-group v-on:enter="bgEnter" v-bind:css="false" v-on:leave="bgLeave" v-if="!app.useMobileVersion">
			<div key="left" v-if="backgroundImages" class="bg-image left" :class="backgroundImages"></div>
			<div key="right" v-if="backgroundImages" class="bg-image right" :class="backgroundImages"></div>
		</transition-group>

		<transition
			v-if="current"
			v-on:before-enter="mapBeforeEnter" 
			v-on:enter="mapEnter"
			v-on:after-enter="mapAfterEnter" 
			v-on:before-leave="mapBeforeLeave" 
			v-on:leave="mapLeave"
			v-bind:css="false">
			<Map :key="current.url" :img="currentImg" :imgRatio="currentImgRatio" :transform="currentTransform" :hotspots="currentHotspots" :children="currentChildren"></Map>
		</transition>

		<nav v-if="current && !app.useMobileVersion" class="container-nav-desktop">
			<NavDesktop :menue="currentMenue" :current="current" />
		</nav>

		<div v-if="app.useMobileVersion" class="container-nav-mobile p-7 pb-10">
			<NavMobile :menue="currentMobileMenue" :hotspots="currentHotspots" :current="current" />
		</div>

	</div>
</template>

<script>

import { mapState } from 'vuex';
import { EventBus } from '@/common/eventbus.js';
import { Log } from '@/services/log.service'
import { Navigation } from '@/services/navigation.service'

import { gsap, TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Expo } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin'

gsap.registerPlugin(CSSPlugin);

export default {
	props: [],
	data: function () {
		return {
			fromType: false,
			toType: false,
			prevNode: false,
			prevMenue: false,
			mapClass: false,
			exitClicks: 0,
		}
	},
	watch: {
		$route(to, from) {
			this.routeChanged( to );
		}
	},
	computed: {
		...mapState('settings', ['presets']),
		...mapState('globals', ['app']),
		...mapState('navigation', ['current']),

		isElectron() {
			return process && process.env && process.env.IS_ELECTRON;
		},
		backgroundColor() {
			var bgcolor = Navigation.getField('bgcolor');
			return `${bgcolor}`;
		},
		backgroundImages() {
			console.log(Navigation.getField('hideBgImages', false, false));
			if (Navigation.getField('hideBgImages', false, false)) return false;
			return Navigation.getField('bgImages') || false;
		},
		rootLine() {
			return Navigation.getRootLine();
		},
		currentImg() {
			if (this.current.img) return this.current.img;
			return this.current.parent ? this.current.parent.img : '';
		},
		currentImgRatio() {
			if (this.current.imgRatio) return this.current.imgRatio;
			return this.current.parent ? this.current.parent.imgRatio : '';
		},
		currentMenue() {
			return this.current.parent ? this.current.parent.children : [];
		},
		currentMobileMenue() {
			return this.current.children;
		},
		currentTransform() {
			var transform = this.app.useMobileVersion && this.current.transformMobile ? this.current.transformMobile : this.current.transform;
			return Object.assign({scale:1, x:0, y:0}, transform || {});
		},
		currentChildren() {
			return this.current.children;
		},
		currentHotspots() {
			return this.current.hotspots;
		},
	},

	mounted() {
		this.routeChanged( this.$route );
		this.mapAfterEnter();
	},

	beforeDestroy() {
	},

	methods: {

		/**
		 * 	Fallback für Position in Parent (falls nicht im navigation.json definiert)
		 * 
		 */
		getPositionInParent( child ) {
			var pos = child.positionInParent;
			if (!pos && child.parent) pos = child.parent.position;
			return Object.assign({x:50, y:50}, pos || {});
		},

		/**
		 * Anwendung beenden
		 * 
		 */
		onClickExit() {
			if (!process.env.IS_ELECTRON) return;
			this.exitClicks++;
			if (this.exitClicks >= 3) {
				var ipcRenderer = require('electron').ipcRenderer;
				ipcRenderer.send('quit-app');
			}
			setTimeout(() => {
				this.exitClicks = 0;
			}, 5000);
		},

		/**
		 * 	Ein/Ausblenden der Hintergrund-Grafiken
		 * 	am linken und rechten Rand.
		 * 
		 */
		bgEnter(el, done) {
			var right = el.classList.contains('right');
			TweenMax.fromTo(el, 2,
				{alpha: 0, scale: 1, x:right ? '100%' : '-100%', transformOrigin: origin},
				{alpha: 1, scale: 1, x:0, delay: 0.4, ease: Power3.easeOut, onComplete: done}
			);
		},
		bgLeave(el, done) {
			var right = el.classList.contains('right');
			TweenMax.fromTo(el, 0.4,
				{alpha: 1, scale: 1, transformOrigin: origin},
				{alpha: 0, scale: 0.5, x:right ? '100%' : '-100%', ease: Power3.easeIn, onComplete: done}
			);
		},

		/**
		 * 	Animationen für Ein/Auszoomen in eine Map
		 * 	bei Wechsel der Levels.
		 * 
		 */
		mapBeforeEnter(el) {
			if (el) el.classList.add('map-enter');
			setTimeout(() => {
				this.mapClass = Navigation.getField('mapClass');			
			}, 400);
		},
		mapEnter(el, done) {

			var relationShip = Navigation.getRelationship(this.prevNode, this.current);
			var posInParent = this.getPositionInParent( relationShip == 'parent' ? this.current : this.prevNode );
			var origin = `${posInParent.x}% ${posInParent.y}%`;

			switch( relationShip ) {
				case 'neighbor':					
					TweenMax.fromTo(el, 0.4,
						{alpha: 0, scale: 1, transformOrigin: origin},
						{alpha: 1, scale: 1, delay: 0.4, ease: Power0.easeNone, onComplete: done}
					);
					break;
				case false:
				case 'parent':
					TweenMax.fromTo(el, 1, 
						{alpha: 0, scale: 0.8, transformOrigin: origin}, 
						{alpha: 1, scale: 1, delay: 0.4, ease: Expo.easeOut, onComplete: done}
					);
					break;
				default:
					TweenMax.fromTo(el, 1, 
						{alpha: 0, scale: 1.2, transformOrigin: origin}, 
						{alpha: 1, scale: 1, delay: 0.4, ease: Expo.easeOut, onComplete: done}
					);
					break;
			}
		},
		mapAfterEnter(el) {
			this.prevNode = this.current;
			this.prevMenue = this.currentMenue;
			if (el) el.classList.remove('map-enter');
		},
		mapBeforeLeave(el) {
			if (el) el.classList.add('map-leave');
		},
		mapLeave(el, done) {

			var relationShip = Navigation.getRelationship(this.prevNode, this.current);
			var posInParent = this.getPositionInParent( relationShip == 'parent' ? this.current : this.prevNode );
			var origin = `${posInParent.x}% ${posInParent.y}%`;

			switch( relationShip ) {
				case 'neighbor':					
					TweenMax.fromTo(el, 0.4,
						{alpha: 1, scale: 1, transformOrigin: origin}, 
						{alpha: 0, scale: 1, ease: Power0.easeNone, onComplete: done}
					);
					break;
				case false:
				case 'parent':
					TweenMax.fromTo(el, 0.6, 
						{alpha: 1, scale: 1, transformOrigin: origin}, 
						{alpha: 0, scale: 1.4, ease: Power1.easeIn, onComplete: done}
					);
					break;
				default:
					TweenMax.fromTo(el, 0.6, 
						{alpha: 1, scale: 1, transformOrigin: origin}, 
						{alpha: 0, scale: 0.6, ease: Power1.easeIn, onComplete: done}
					);
					break;
			}
		},

		/**
		 * 	Wird bei Navigation / Ändern des URL-Pfades aufgerufen.
		 * 	Sucht in navigation.json nach Node anhand des URL-Pfades,
		 * 	setzt das Object in $store: globals.nav.current
		 * 
		 */
		routeChanged( route ) {

			// Aktuellen Node in navigation.json anhand des URL-Pfades finden
			var node = Navigation.findNodeByPath( route.params.pathMatch );

			if (!node) {
				return Log.ERROR('Page->routeChanged()', `Pfadsegment '${route.params.pathMatch}' unbekannt`);
			}
			
			this.preloadImages('assets/maps/' + node.img).then(( image ) => {
				if (!node.imgRatio) {
					node.imgRatio = image.width/image.height;
				}
				this.$store.commit('navigation/SET_CURRENT', node);
			});

		}
	}
}
</script>

<style scoped lang="scss">
	.exit {
		background: rgba(#fff, 0);
		@include position( fixed, auto 0 0 auto, 100, 5rem, 5rem);
	}
	.bg-image {
		position: fixed;
		pointer-events: none;
		background: transparent none top left no-repeat;
		background-size: contain;
		z-index: 10;
		&.left {
			bottom: 0;
			left: 0;
			background-image: url(/assets/images/hg-krankenhaus-links.svg);
			width: 20%;
			padding-top: 20%;
		}
		&.right {
			top: 100px;
			right: -20px;
			background-image: url(/assets/images/hg-krankenhaus-rechts.svg);
			width: 15%;
			padding-top: 20%;
		}

		&.pflege {
			&.left {
				background-image: url(/assets/images/hg-pflege-links.svg);
			}
			&.right {
				background-image: url(/assets/images/hg-pflege-rechts.svg);
			}
		}
	}

	.container-nav-desktop {
		transform: translateY(-70px);
		padding: 0 0 0 1rem;
		@media ($min-device-width-md) {
			transform: translateY(-80px);
			padding: 0 0 0 2rem;
		}
		@media ($min-device-width-lg) {
			transform: translateY(-40px);
			padding: 0 0 0 5rem;
		}
		position: absolute;
		z-index: 20;
	}

	.container-nav-mobile {
		@include position( absolute, 60% 0 0 0, 10);
		background: darken(#bee2e0, 10%);
		box-shadow: inset 0 20px 15px -20px rgba(#000, 0.2);
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.pflege .container-nav-mobile {
		background: darken(#b2e3f2, 10%);
	}

	h1 {
		color: #fff;
	}
	.logo {
		@include position( absolute, 15px auto auto 15px, 10 );
		max-width: 120px;
		@media ($min-device-width-sm) {
			top: 15px;
			right: 15px;
			left: auto;
		}
		@media ($min-device-width-md) {
			top: 30px;
			right: 30px;
			max-width: 200px;
		}
	}
	.index-component {
		overflow: hidden;
		@include position(absolute, 0 0 0 0);
		transition: background-color 0.2s linear 0.4s;
		overflow-y: hidden;
	}
	
</style>
